import { createContext } from 'react';

import queryString from 'query-string';

import { useViolation } from '@/hooks/queries/violations';
import useMedia, {
  INITIAL_MEDIA_VALUES,
  MediaStateType
} from '@/hooks/useMedia';
import { errorApp } from '@/models/misc';
import { Posts } from '@/models/posts';
import { Violations } from '@/models/violations';

interface ViolationContextType extends MediaStateType {
  postId: number;
  postData?: Posts.Details;
  violationData?: Violations.Details | undefined;
  isLoading: boolean;
  isError: boolean;
  error?: errorApp;
  resetState: () => void;
  urlParams: queryString.ParsedQuery<string>;
}

const INITIAL_VALUES: ViolationContextType = {
  postId: 0,
  postData: undefined,
  violationData: undefined,
  isLoading: false,
  urlParams: {},
  resetState: () => {},
  isError: false,
  error: undefined,
  ...INITIAL_MEDIA_VALUES
};

export const ViolationContext =
  createContext<ViolationContextType>(INITIAL_VALUES);

interface Props {
  children: React.JSX.Element;
  postId: number;
  urlParams: queryString.ParsedQuery<string>;
}

export const ViolationProvider = ({ children, postId, urlParams }: Props) => {
  const mediaState = useMedia();

  const {
    data: violationData,
    isLoading,
    isError,
    error
  } = useViolation({
    postId,
    params: { ...urlParams }
  });

  const resetState = () => {
    mediaState.resetMediaState();
  };

  const value: ViolationContextType = {
    postId,
    violationData,
    isLoading,
    isError,
    error,
    resetState,
    urlParams,
    ...mediaState
  };

  return (
    <ViolationContext.Provider value={value}>
      {children}
    </ViolationContext.Provider>
  );
};
